import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

const slides = [
  {
    src: "/assets/banner4.jpg",
    video: "/assets/hero.mp4",
    alt: "Ready to wear",
    title: "Winter '26",
    accent: "Ready to Wear",
    href: "/shop?category=ready-to-wear",
  },
  {
    src: "/assets/images/carousel2.JPG",
    alt: "Formal wear",
    title: "Winter '26",
    accent: "Formal Wear",
    href: "/shop?category=formal-wear",
  },
  // {
  //   src: "/assets/banner1.jpg",
  //   alt: "Unstitched collection",
  //   title: "Winter '26",
  //   accent: "Unstitched",
  //   href: "/shop?category=unstitched",
  // },
];

export default function HeroSection() {
  const [index, setIndex] = useState(0);
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const delay = slides[index].video ? 9000 : 3500;
    const timer = window.setInterval(() => {
      setIndex((current) => (current + 1) % slides.length);
    }, delay);
    return () => window.clearInterval(timer);
  }, [index]);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    if (slides[index].video) {
      video.play().catch(() => {});
    } else {
      video.pause();
    }
  }, [index]);

  const go = (next: number) => {
    setIndex((next + slides.length) % slides.length);
  };

  return (
    <div className="hero" aria-roledescription="carousel">
      <div
        className="hero-track"
        style={{
          ["--count" as string]: slides.length,
          width: `${slides.length * 100}%`,
          transform: `translateX(-${(index * 100) / slides.length}%)`,
        }}
      >
        {slides.map((slide) => (
          <div className="hero-slide" key={slide.href}>
            {slide.video ? (
              <video
                ref={videoRef}
                src={slide.video}
                poster={slide.src}
                muted
                loop
                playsInline
                autoPlay
                preload="metadata"
                aria-label={slide.alt}
              />
            ) : (
              <img src={slide.src} alt={slide.alt} />
            )}
          </div>
        ))}
      </div>
      <button
        className="hnav hprev"
        aria-label="Previous"
        onClick={() => go(index - 1)}
      >
        &#8249;
      </button>
      <button
        className="hnav hnext"
        aria-label="Next"
        onClick={() => go(index + 1)}
      >
        &#8250;
      </button>
      <div className="hdots">
        {slides.map((slide, dot) => (
          <button
            key={slide.href}
            className={dot === index ? "on" : ""}
            aria-label={`Show slide ${dot + 1}`}
            onClick={() => go(dot)}
          />
        ))}
      </div>
      <div className="htxt">
        <h2 className="htitle">{slides[index].title}</h2>
        <p className="hsub">{slides[index].accent}</p>
        <Link className="hshop" to={slides[index].href}>
          Shop Now
        </Link>
      </div>
    </div>
  );
}
